// Booking terms, worded as in the uplift mockup; the cancellation term matches the self-serve
// booking (patient-ui CANCELLATION_POLICY_SECTIONS). `name` groups them in the client PDF
// (booking-provider-api templates/telecare/html.pug), so keep it as is; `title` is what the patient sees.
export const TERMS = {
  isAgreedTheFees: {
    name: 'Fees and Cancellation Policy',
    title: 'Medical Consultation Financial Consent',
    paragraphs: [
      'You accept the medical service fee/s provided to you during the booking process and will contact Telecare to clarify fees and payment options if required and at least 2 business days before your appointment.',
      'You agree to pay the full fee using the payment link Telecare sends you after you book. If we have not received your payment 3 business days before your appointment, we will send you a reminder. Appointments that remain unpaid may be cancelled or rescheduled. If a payment is declined, you may be subject to a late payment administration fee.',
    ],
  },
  isAgreedTheCancelPolicy: {
    name: 'Fees and Cancellation Policy',
    title: 'Cancellation Policy',
    paragraphs: [
      'Please understand that our specialists and your GPs have reserved their time for you. If you must cancel your appointment, we respectfully request 2 business days notice so we have time to organise another patient who needs this service.',
      'Missed appointments, or appointments cancelled without valid medical reason within 2 business days of the appointment will incur a fee ($150).',
    ],
  },
  isAgreedTheContact: {
    name: 'Fees and Cancellation Policy',
    title: 'How we contact you',
    paragraphs: [
      'Your video link arrives by SMS and email. Sent 3 business days and again 30 minutes before your appointment.',
      'The Telecare team may contact you about supporting documents, diagnostic reports or questionnaires needed for this appointment.',
    ],
  },
  isAgreedTheMedicareClaiming: {
    name: 'Fees and Cancellation Policy',
    title: 'Medicare claiming',
    paragraphs: [
      'We lodge your Medicare claim within 3 business days of you attending your appointment. Medicare pays any rebate straight into your nominated bank account — the rebate may vary based on your eligibility.',
    ],
  },
};

export type TermKey = keyof typeof TERMS;

export const CONSENTS_MAPPING = {
  isAgreedThePrivacyPolicy: {
    name: 'Consents',
    description: 'I have read Telecare\'s Privacy Policy. I understand the information in this form will be accessed by Telecare\'s practice management and reception team, and by Telecare\'s clinicians so I receive optimal care.',
  },
};
